import { axiosRequest } from '@/util/axios-request'

const method = 'get'
// const resignlist = '/web/approval/resignlist'
const lists = '/web/staff_resign/lists'
const addResignUrl = '/web/staff_resign/addResign'
const editResignUrl = '/web/staff_resign/editResign'
const cancelResignUrl = '/web/staff_resign/cancelResign'
const exportUrl = '/web/staff_resign/export'
const detail = '/web/approval/detail'
const deleteStaff = '/web/staff/remove'
const inviteStaffData = '/web/staff/inviteStaffData'
const inviteStaffRegister = '/web/staff/inviteStaffRegister'
const staffresign = '/web/staff_resign/init'
const StaffAuditResign = '/web/staff_resign/getStaffAuditResign'
const IsWaitAudit = '/web/approval/isWaitAudit'

// 离职管理列表
export const getResignlist = params => axiosRequest({ url: lists, method, params })
// 办理离职
export const addResign = data => axiosRequest({ url: addResignUrl, data })
// 编辑离职信息
export const editResign = data => axiosRequest({ url: editResignUrl, data })
// 恢复在职
export const cancelResign = data => axiosRequest({ url: cancelResignUrl, data })
// 离职管理列表导出
export const exportExcel = params => axiosRequest({ url: exportUrl, method, params })
// 详情接口 /web/approval/detail
export const getDetail = params => axiosRequest({ url: detail, params })
// 员工删除
export const deleteStaffFun = params => axiosRequest({ url: deleteStaff, params })

// 邀请员工时获取当前激活和未激活员工数量
export const getInviteStaffData = data => axiosRequest({ url: inviteStaffData, data })

// 发送邀请员工短信
export const inviteStaffRegisterFn = data => axiosRequest({ url: inviteStaffRegister, data })

// 离职管理枚举项
export const getInit = data => axiosRequest({ url: staffresign, data })

// 查询是否有进行中的离职审批流
export const getStaffAuditResign = data => axiosRequest({ url: StaffAuditResign, data })

// 判断当前员工是否有独自待审批节点任务
export const isWaitAudit = data => axiosRequest({ url: IsWaitAudit, data })
